import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

export const Wrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  @media (max-width: ${BP_LAPTOP}px) {
    grid-column-gap: 6px;
  }
`;
